const companiesModel = vm => ({
  title: vm.$gettext('Companies'),
  endpoint: 'companies',
  allowNew: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'business_name',
      label: vm.$gettext('Business Name'),
      sortable: true,
      editable: true,
      required: false
    },
    {
      key: 'tin',
      label: vm.$gettext('TIN'),
      editable: true,
      required: true
    },
    {
      key: 'contact_name',
      label: vm.$gettext('Contact Name'),
      editable: true,
      required: true
    },
    {
      key: 'email',
      label: vm.$gettext('Email'),
      editable: true,
      required: true
    },
    {
      key: 'phone',
      label: vm.$gettext('Phone'),
      editable: true,
      required: true
    },
    {
      key: 'address',
      label: vm.$gettext('Address'),
      editable: true,
      required: true
    },
    {
      key: 'logo',
      label: vm.$gettext('Logo'),
      editable: true
    },
    {
      key: 'relationship',
      label: vm.$gettext('Relationship'),
      sortable: true,
      editable: true
    },
    {
      key: 'tags',
      label: vm.$gettext('Tags'),
      editable: false,
      sortable: false
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      editable: true,
      required: true,
      description: vm.$gettext('Country ISO 3166-1 alpha 2 code (ie. AR or BR)')
    }
  ],
  filters: [
    'id',
    'name',
    'business_name',
    'tin',
    'contact_name',
    'email',
    'phone',
    'country_iso_code',
    'relationship',
    'tags.name'
  ],
  exclude: ['address', 'logo'],
  includes: ['tags', 'account']
})

export default companiesModel
